import Routes from '@/util/Routes';
import OrderStore from '@/stores/order/order.store';

export enum Step {
  ADDRESS = 1,
  DELIVERY,
  PAYMENT,
  SUMMARY,
}

export const Steps = {
  getRoute(step: Step) {
    switch (step) {
      case Step.ADDRESS:
        return Routes.OrderAddressStep;
      case Step.DELIVERY:
        return Routes.OrderDeliveryStep;
      case Step.PAYMENT:
        return Routes.OrderPaymentStep;
      case Step.SUMMARY:
        return Routes.OrderSummaryStep;
      default:
        throw Error('Unknown checkout step');
    }
  },
  isStepFinished(step: Step, orderStore: OrderStore): boolean {
    switch (step) {
      case Step.ADDRESS:
        return orderStore.currentDeliveryAddress !== null && orderStore.currentBillingAddress !== null &&
          (orderStore.isGuestOrder ?
              (!!orderStore.currentBirthday && !!orderStore.currentConfirmationMailAddress) :
              true
          );
      case Step.DELIVERY:
        return orderStore.currentDeliverySlot !== null;
      case Step.PAYMENT:
        return orderStore.currentPaymentMethod !== null;
      case Step.SUMMARY:
        return true;
      default:
        return false;
    }
  },
  getLastStep() {
    return Step.SUMMARY;
  },
  isLastStep(step: Step) {
    return step === this.getLastStep();
  },
};
